import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-incorrect-mark",
  "use": "foquz-icon-incorrect-mark-usage",
  "viewBox": "0 0 10 2",
  "content": "<symbol viewBox=\"0 0 10 2\" fill=\"none\" id=\"foquz-icon-incorrect-mark\"><path d=\"M1 1h8\" stroke=\"red\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol